import type { IntroCardInput } from "@/types/pageData";
export interface Input {
  cards: IntroCardInput["influencer"][];
  index: number;
  imagesLoaded?: Record<number, boolean>;
}
$ const { cards, index, imagesLoaded } = input;

<if(imagesLoaded && Object.keys(imagesLoaded).length > 0)>
  <for|card, i| of=cards>
    <if(imagesLoaded[i])>
      <img
        src=(card.image.imageUrl)
        alt=""
        class=["cast-intro-cards__card-image", index !== i && "display-none"]
      >
      <if(card.name)>
        <span class=[
          "cast-intro-cards__card-text",
          index !== i && "display-none",
        ]>
          ${card.name}
        </span>
      </if>
    </if>
  </for>
</if>
<else>
  <ebay-skeleton class="card-skeleton">
    <ebay-skeleton-image class="card-skeleton-image"/>
  </ebay-skeleton>
</else>

style {
  .display-none {
    display: none;
  }

  .card-skeleton {
    width: var(--card-min-width) !important;
  }

  .card-skeleton-image {
    width: var(--card-min-width);
    height: 0;
    padding-bottom: 133%;
  }
}
